import {ENDPOINT_LOCATION} from 'common/endpoints';
import goStore from 'go/store';
import {getInfo} from 'common/storeUtils';
import _ from 'lodash';
import {commonJwtHeader, commonJwtHeaderNoCT} from 'common/utils';

//creating a new item project inventory item
const createProjectInventoryItem = (
  token,
  item,
  entityId,
  entityType = 'subApplication'
) => {
  // TODO remove OpenAPI toggle code
  const {baseUrl: endPointBase, isV2} = getInfo(
    goStore.store.getState(),
    ENDPOINT_LOCATION
  );
  const endpointToUse = `${endPointBase}site-inventories?entityType=${entityType}&entityId=${entityId}`;

  return fetch(endpointToUse, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(item),
  });
};

const getInventoryList = (token, entityId, entityType = 'subApplication') => {
  // TODO remove OpenAPI toggle code
  const {baseUrl: endPointBase, isV2} = getInfo(
    goStore.store.getState(),
    ENDPOINT_LOCATION
  );

  const endpointToUse = `${endPointBase}site-inventories?entityType=${entityType}&entityId=${entityId}`;
  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const uploadFileData = (token, formData, entityId, entityType = 'subApplication') => {
  // TODO remove OpenAPI toggle code
  const {baseUrl: endPointBase, isV2} = getInfo(
    goStore.store.getState(),
    ENDPOINT_LOCATION
  );

  const endpointToUse = `${endPointBase}site-inventories/spreadSheet?entityType=${entityType}&entityId=${entityId}`;
  return fetch(endpointToUse, {
    method: 'POST',
    headers: commonJwtHeaderNoCT(),
    body: formData,
  });
};

const disassociateProjectSite = (token, id) => {
  // TODO remove OpenAPI toggle code
  const {baseUrl: endPointBase} = getInfo(goStore.store.getState(), ENDPOINT_LOCATION);

  return fetch(`${endPointBase}site-inventories/${id}`, {
    method: 'DELETE',
    headers: commonJwtHeader(),
  });
};

//Open to with one entry's details, that can be edited
const getProjectSiteDetails = (token, id) => {
  // TODO remove OpenAPI toggle code
  const {baseUrl: endPointBase} = getInfo(goStore.store.getState(), ENDPOINT_LOCATION);

  return fetch(`${endPointBase}site-inventories/${id}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

//put/update modified entry into DB
//Open to with one entry's details, that can be edited
const updateProjectSiteDetails = (token, item) => {
  // TODO remove OpenAPI toggle code
  const {baseUrl: endPointBase, isV2} = getInfo(
    goStore.store.getState(),
    ENDPOINT_LOCATION
  );

  const entityId = _.get(item, 'entityId');
  const entityType = _.get(item, 'entityType');

  const endpointToUse = `${endPointBase}site-inventories?entityType=${entityType}&entityId=${entityId}`;

  return fetch(endpointToUse, {
    method: 'PUT',
    headers: commonJwtHeader(),
    body: JSON.stringify(item),
  });
};

const getMitigatedPropertyData = (id) => {
  const {baseUrl: endPointBase} = getInfo(goStore.store.getState(), ENDPOINT_LOCATION);

  const endpointToUse = `${endPointBase}/site-inventories/${id}/mitigation-data`;

  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const createMitigatedPropertyData = (id, data) => {
  const {baseUrl: endPointBase} = getInfo(goStore.store.getState(), ENDPOINT_LOCATION);

  const endpointToUse = `${endPointBase}/site-inventories/${id}/mitigation-data`;

  return fetch(endpointToUse, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(data),
  });
};

const updateMitigatedPropertyData = (id, data) => {
  const {baseUrl: endPointBase} = getInfo(goStore.store.getState(), ENDPOINT_LOCATION);

  const endpointToUse = `${endPointBase}/site-inventories/${id}/mitigation-data`;

  return fetch(endpointToUse, {
    method: 'PUT',
    headers: commonJwtHeader(),
    body: JSON.stringify(data),
  });
};

const deleteMitigatedPropertyData = (id) => {
  const {baseUrl: endPointBase} = getInfo(goStore.store.getState(), ENDPOINT_LOCATION);

  const endpointToUse = `${endPointBase}/site-inventories/${id}/mitigation-data`;

  return fetch(endpointToUse, {
    method: 'DELETE',
    headers: commonJwtHeader(),
  });
};

export default {
  createProjectInventoryItem,
  getInventoryList,
  uploadFileData,
  disassociateProjectSite,
  getProjectSiteDetails,
  updateProjectSiteDetails,
  getMitigatedPropertyData,
  createMitigatedPropertyData,
  updateMitigatedPropertyData,
  deleteMitigatedPropertyData,
};
